import {AxiosPromise} from "axios";
import {CONSTANT_CONFIG} from "../../constants";
import { HttpService } from "../../services/http.services";

const RESOURCE_ENDPOINT = `${CONSTANT_CONFIG.QIS_SERVER_PREFIX}/import`
const endpoints = {
    importExample: () => `${RESOURCE_ENDPOINT}/example`,
    importFertilizerAllocation: () => `${RESOURCE_ENDPOINT}/fertilizer-allocation`,

}

export default class ImportFertilizerApi {
    public importExample = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.importExample();
        return HttpService.post(url, payload, params, headers);
    }
    public importFertilizerAllocation = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.importFertilizerAllocation();
        return HttpService.post(url, payload, params, headers);
    }
}

